// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import { SpeciesFieldsFragmentDoc } from './species.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddOnFormFieldsFragment = { __typename?: 'AddOn', id: string, name: string, listings: Array<string>, category: string, deposit_percentage?: number | null, unit_price: number, deposit_amount?: number | null, offer_period: Types.AddOnOfferPeriod, is_enabled: boolean, apply_to_all_listings?: boolean | null, is_hidden_from_sportsmen?: boolean | null, is_hidden_from_outfitters?: boolean | null, created_at: number, updated_at: number, images?: Array<string> | null, description?: string | null, price_by_day?: Types.PriceByDay | null, price_by_guest?: Types.PriceByGuest | null, label?: string | null, sub_label?: string | null, unit_price_label?: string | null, order?: number | null, applied_tax_definition_ids?: Array<string> | null, species?: { __typename?: 'Species', id: string, type: Types.SpeciesType, name: string, keywords?: Array<string> | null, is_archived: boolean } | null };

export type BookingAddOnFieldsFragment = { __typename?: 'QuoteAddOn', id: string, package_id?: string | null, name: string, category: string, note?: string | null, unit_price: number, deposit_amount?: number | null, deposit_percentage?: number | null, offer_period: Types.AddOnOfferPeriod, quantity: number, price_by_day?: Types.PriceByDay | null, price_by_guest?: Types.PriceByGuest | null };

export type MinimalBookingAddOnFieldsFragment = { __typename?: 'QuoteAddOn', id: string, package_id?: string | null, name: string, quantity: number, category: string };

export type GetAddOnsByOutfitterAndOfferPeriodQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
  offerPeriod: Types.AddOnOfferPeriod;
}>;


export type GetAddOnsByOutfitterAndOfferPeriodQuery = { __typename?: 'Query', getAddOnsByOutfitterAndOfferPeriod: Array<{ __typename?: 'AddOn', id: string, name: string, listings: Array<string>, category: string, deposit_percentage?: number | null, unit_price: number, deposit_amount?: number | null, offer_period: Types.AddOnOfferPeriod, is_enabled: boolean, apply_to_all_listings?: boolean | null, is_hidden_from_sportsmen?: boolean | null, is_hidden_from_outfitters?: boolean | null, created_at: number, updated_at: number, images?: Array<string> | null, description?: string | null, price_by_day?: Types.PriceByDay | null, price_by_guest?: Types.PriceByGuest | null, label?: string | null, sub_label?: string | null, unit_price_label?: string | null, order?: number | null, applied_tax_definition_ids?: Array<string> | null, species?: { __typename?: 'Species', id: string, type: Types.SpeciesType, name: string, keywords?: Array<string> | null, is_archived: boolean } | null }> };

export type GetDefaultImageQueryVariables = Types.Exact<{
  species?: Types.InputMaybe<Types.Scalars['String']['input']>;
  category?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetDefaultImageQuery = { __typename?: 'Query', getDefaultImage?: string | null };

export type GetAddOnsByListingAndOfferPeriodQueryVariables = Types.Exact<{
  listingId: Types.Scalars['ID']['input'];
  offerPeriod: Types.AddOnOfferPeriod;
  idsToAlwaysInclude?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type GetAddOnsByListingAndOfferPeriodQuery = { __typename?: 'Query', getAddOnsByListingAndOfferPeriod: Array<{ __typename?: 'AddOn', id: string, name: string, listings: Array<string>, category: string, deposit_percentage?: number | null, unit_price: number, deposit_amount?: number | null, offer_period: Types.AddOnOfferPeriod, is_enabled: boolean, apply_to_all_listings?: boolean | null, is_hidden_from_sportsmen?: boolean | null, is_hidden_from_outfitters?: boolean | null, created_at: number, updated_at: number, images?: Array<string> | null, description?: string | null, price_by_day?: Types.PriceByDay | null, price_by_guest?: Types.PriceByGuest | null, label?: string | null, sub_label?: string | null, unit_price_label?: string | null, order?: number | null, applied_tax_definition_ids?: Array<string> | null, species?: { __typename?: 'Species', id: string, type: Types.SpeciesType, name: string, keywords?: Array<string> | null, is_archived: boolean } | null }> };

export type GetAddOnsForBookingQueryVariables = Types.Exact<{
  bookingId: Types.Scalars['ID']['input'];
}>;


export type GetAddOnsForBookingQuery = { __typename?: 'Query', booking: { __typename?: 'Booking', id: string, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, package_id?: string | null, name: string, category: string, note?: string | null, unit_price: number, deposit_amount?: number | null, deposit_percentage?: number | null, offer_period: Types.AddOnOfferPeriod, quantity: number, price_by_day?: Types.PriceByDay | null, price_by_guest?: Types.PriceByGuest | null }> | null } };

export type CreateAddOnMutationVariables = Types.Exact<{
  data: Types.CreateAddOnInput;
}>;


export type CreateAddOnMutation = { __typename?: 'Mutation', createAddOn: { __typename?: 'AddOn', id: string, name: string, listings: Array<string>, category: string, deposit_percentage?: number | null, unit_price: number, deposit_amount?: number | null, offer_period: Types.AddOnOfferPeriod, is_enabled: boolean, apply_to_all_listings?: boolean | null, is_hidden_from_sportsmen?: boolean | null, is_hidden_from_outfitters?: boolean | null, created_at: number, updated_at: number, images?: Array<string> | null, description?: string | null, price_by_day?: Types.PriceByDay | null, price_by_guest?: Types.PriceByGuest | null, label?: string | null, sub_label?: string | null, unit_price_label?: string | null, order?: number | null, applied_tax_definition_ids?: Array<string> | null, species?: { __typename?: 'Species', id: string, type: Types.SpeciesType, name: string, keywords?: Array<string> | null, is_archived: boolean } | null } };

export type UpdateAddOnMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  data: Types.UpdateAddOnInput;
}>;


export type UpdateAddOnMutation = { __typename?: 'Mutation', updateAddOn: { __typename?: 'AddOn', id: string, name: string, listings: Array<string>, category: string, deposit_percentage?: number | null, unit_price: number, deposit_amount?: number | null, offer_period: Types.AddOnOfferPeriod, is_enabled: boolean, apply_to_all_listings?: boolean | null, is_hidden_from_sportsmen?: boolean | null, is_hidden_from_outfitters?: boolean | null, created_at: number, updated_at: number, images?: Array<string> | null, description?: string | null, price_by_day?: Types.PriceByDay | null, price_by_guest?: Types.PriceByGuest | null, label?: string | null, sub_label?: string | null, unit_price_label?: string | null, order?: number | null, applied_tax_definition_ids?: Array<string> | null, species?: { __typename?: 'Species', id: string, type: Types.SpeciesType, name: string, keywords?: Array<string> | null, is_archived: boolean } | null } };

export type RemoveAddOnMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RemoveAddOnMutation = { __typename?: 'Mutation', removeAddOn?: any | null };

export type UpdateAddOnOrdersMutationVariables = Types.Exact<{
  data: Array<Types.UpdateAddOnOrderInput> | Types.UpdateAddOnOrderInput;
}>;


export type UpdateAddOnOrdersMutation = { __typename?: 'Mutation', updateAddOnOrders: Array<{ __typename?: 'AddOn', id: string, name: string, listings: Array<string>, category: string, deposit_percentage?: number | null, unit_price: number, deposit_amount?: number | null, offer_period: Types.AddOnOfferPeriod, is_enabled: boolean, apply_to_all_listings?: boolean | null, is_hidden_from_sportsmen?: boolean | null, is_hidden_from_outfitters?: boolean | null, created_at: number, updated_at: number, images?: Array<string> | null, description?: string | null, price_by_day?: Types.PriceByDay | null, price_by_guest?: Types.PriceByGuest | null, label?: string | null, sub_label?: string | null, unit_price_label?: string | null, order?: number | null, applied_tax_definition_ids?: Array<string> | null, species?: { __typename?: 'Species', id: string, type: Types.SpeciesType, name: string, keywords?: Array<string> | null, is_archived: boolean } | null }> };

export const AddOnFormFieldsFragmentDoc = gql`
    fragment AddOnFormFields on AddOn {
  id
  name
  listings
  category
  species {
    ...SpeciesFields
  }
  deposit_percentage
  unit_price
  deposit_amount
  offer_period
  is_enabled
  apply_to_all_listings
  is_hidden_from_sportsmen
  is_hidden_from_outfitters
  created_at
  updated_at
  images
  description
  price_by_day
  price_by_guest
  label
  sub_label
  unit_price_label
  order
  applied_tax_definition_ids
}
    ${SpeciesFieldsFragmentDoc}`;
export const BookingAddOnFieldsFragmentDoc = gql`
    fragment BookingAddOnFields on QuoteAddOn {
  id
  package_id
  name
  category
  note
  unit_price
  deposit_amount
  deposit_percentage
  offer_period
  quantity
  price_by_day
  price_by_guest
}
    `;
export const MinimalBookingAddOnFieldsFragmentDoc = gql`
    fragment MinimalBookingAddOnFields on QuoteAddOn {
  id
  package_id
  name
  quantity
  category
}
    `;
export const GetAddOnsByOutfitterAndOfferPeriodDocument = gql`
    query getAddOnsByOutfitterAndOfferPeriod($outfitterId: ID!, $offerPeriod: AddOnOfferPeriod!) {
  getAddOnsByOutfitterAndOfferPeriod(
    outfitterId: $outfitterId
    offerPeriod: $offerPeriod
  ) {
    ...AddOnFormFields
  }
}
    ${AddOnFormFieldsFragmentDoc}`;

/**
 * __useGetAddOnsByOutfitterAndOfferPeriodQuery__
 *
 * To run a query within a React component, call `useGetAddOnsByOutfitterAndOfferPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddOnsByOutfitterAndOfferPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddOnsByOutfitterAndOfferPeriodQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *      offerPeriod: // value for 'offerPeriod'
 *   },
 * });
 */
export function useGetAddOnsByOutfitterAndOfferPeriodQuery(baseOptions: Apollo.QueryHookOptions<GetAddOnsByOutfitterAndOfferPeriodQuery, GetAddOnsByOutfitterAndOfferPeriodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddOnsByOutfitterAndOfferPeriodQuery, GetAddOnsByOutfitterAndOfferPeriodQueryVariables>(GetAddOnsByOutfitterAndOfferPeriodDocument, options);
      }
export function useGetAddOnsByOutfitterAndOfferPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddOnsByOutfitterAndOfferPeriodQuery, GetAddOnsByOutfitterAndOfferPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddOnsByOutfitterAndOfferPeriodQuery, GetAddOnsByOutfitterAndOfferPeriodQueryVariables>(GetAddOnsByOutfitterAndOfferPeriodDocument, options);
        }
export type GetAddOnsByOutfitterAndOfferPeriodQueryHookResult = ReturnType<typeof useGetAddOnsByOutfitterAndOfferPeriodQuery>;
export type GetAddOnsByOutfitterAndOfferPeriodLazyQueryHookResult = ReturnType<typeof useGetAddOnsByOutfitterAndOfferPeriodLazyQuery>;
export type GetAddOnsByOutfitterAndOfferPeriodQueryResult = Apollo.QueryResult<GetAddOnsByOutfitterAndOfferPeriodQuery, GetAddOnsByOutfitterAndOfferPeriodQueryVariables>;
export const GetDefaultImageDocument = gql`
    query getDefaultImage($species: String, $category: String) {
  getDefaultImage(species: $species, category: $category)
}
    `;

/**
 * __useGetDefaultImageQuery__
 *
 * To run a query within a React component, call `useGetDefaultImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultImageQuery({
 *   variables: {
 *      species: // value for 'species'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetDefaultImageQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultImageQuery, GetDefaultImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultImageQuery, GetDefaultImageQueryVariables>(GetDefaultImageDocument, options);
      }
export function useGetDefaultImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultImageQuery, GetDefaultImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultImageQuery, GetDefaultImageQueryVariables>(GetDefaultImageDocument, options);
        }
export type GetDefaultImageQueryHookResult = ReturnType<typeof useGetDefaultImageQuery>;
export type GetDefaultImageLazyQueryHookResult = ReturnType<typeof useGetDefaultImageLazyQuery>;
export type GetDefaultImageQueryResult = Apollo.QueryResult<GetDefaultImageQuery, GetDefaultImageQueryVariables>;
export const GetAddOnsByListingAndOfferPeriodDocument = gql`
    query getAddOnsByListingAndOfferPeriod($listingId: ID!, $offerPeriod: AddOnOfferPeriod!, $idsToAlwaysInclude: [ID!]) {
  getAddOnsByListingAndOfferPeriod(
    listingId: $listingId
    offerPeriod: $offerPeriod
    idsToAlwaysInclude: $idsToAlwaysInclude
  ) {
    ...AddOnFormFields
  }
}
    ${AddOnFormFieldsFragmentDoc}`;

/**
 * __useGetAddOnsByListingAndOfferPeriodQuery__
 *
 * To run a query within a React component, call `useGetAddOnsByListingAndOfferPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddOnsByListingAndOfferPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddOnsByListingAndOfferPeriodQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      offerPeriod: // value for 'offerPeriod'
 *      idsToAlwaysInclude: // value for 'idsToAlwaysInclude'
 *   },
 * });
 */
export function useGetAddOnsByListingAndOfferPeriodQuery(baseOptions: Apollo.QueryHookOptions<GetAddOnsByListingAndOfferPeriodQuery, GetAddOnsByListingAndOfferPeriodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddOnsByListingAndOfferPeriodQuery, GetAddOnsByListingAndOfferPeriodQueryVariables>(GetAddOnsByListingAndOfferPeriodDocument, options);
      }
export function useGetAddOnsByListingAndOfferPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddOnsByListingAndOfferPeriodQuery, GetAddOnsByListingAndOfferPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddOnsByListingAndOfferPeriodQuery, GetAddOnsByListingAndOfferPeriodQueryVariables>(GetAddOnsByListingAndOfferPeriodDocument, options);
        }
export type GetAddOnsByListingAndOfferPeriodQueryHookResult = ReturnType<typeof useGetAddOnsByListingAndOfferPeriodQuery>;
export type GetAddOnsByListingAndOfferPeriodLazyQueryHookResult = ReturnType<typeof useGetAddOnsByListingAndOfferPeriodLazyQuery>;
export type GetAddOnsByListingAndOfferPeriodQueryResult = Apollo.QueryResult<GetAddOnsByListingAndOfferPeriodQuery, GetAddOnsByListingAndOfferPeriodQueryVariables>;
export const GetAddOnsForBookingDocument = gql`
    query getAddOnsForBooking($bookingId: ID!) {
  booking(id: $bookingId) {
    id
    add_ons {
      ...BookingAddOnFields
    }
  }
}
    ${BookingAddOnFieldsFragmentDoc}`;

/**
 * __useGetAddOnsForBookingQuery__
 *
 * To run a query within a React component, call `useGetAddOnsForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddOnsForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddOnsForBookingQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetAddOnsForBookingQuery(baseOptions: Apollo.QueryHookOptions<GetAddOnsForBookingQuery, GetAddOnsForBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddOnsForBookingQuery, GetAddOnsForBookingQueryVariables>(GetAddOnsForBookingDocument, options);
      }
export function useGetAddOnsForBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddOnsForBookingQuery, GetAddOnsForBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddOnsForBookingQuery, GetAddOnsForBookingQueryVariables>(GetAddOnsForBookingDocument, options);
        }
export type GetAddOnsForBookingQueryHookResult = ReturnType<typeof useGetAddOnsForBookingQuery>;
export type GetAddOnsForBookingLazyQueryHookResult = ReturnType<typeof useGetAddOnsForBookingLazyQuery>;
export type GetAddOnsForBookingQueryResult = Apollo.QueryResult<GetAddOnsForBookingQuery, GetAddOnsForBookingQueryVariables>;
export const CreateAddOnDocument = gql`
    mutation createAddOn($data: CreateAddOnInput!) {
  createAddOn(data: $data) {
    ...AddOnFormFields
  }
}
    ${AddOnFormFieldsFragmentDoc}`;
export type CreateAddOnMutationFn = Apollo.MutationFunction<CreateAddOnMutation, CreateAddOnMutationVariables>;

/**
 * __useCreateAddOnMutation__
 *
 * To run a mutation, you first call `useCreateAddOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddOnMutation, { data, loading, error }] = useCreateAddOnMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAddOnMutation(baseOptions?: Apollo.MutationHookOptions<CreateAddOnMutation, CreateAddOnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAddOnMutation, CreateAddOnMutationVariables>(CreateAddOnDocument, options);
      }
export type CreateAddOnMutationHookResult = ReturnType<typeof useCreateAddOnMutation>;
export type CreateAddOnMutationResult = Apollo.MutationResult<CreateAddOnMutation>;
export type CreateAddOnMutationOptions = Apollo.BaseMutationOptions<CreateAddOnMutation, CreateAddOnMutationVariables>;
export const UpdateAddOnDocument = gql`
    mutation updateAddOn($id: ID!, $data: UpdateAddOnInput!) {
  updateAddOn(id: $id, data: $data) {
    ...AddOnFormFields
  }
}
    ${AddOnFormFieldsFragmentDoc}`;
export type UpdateAddOnMutationFn = Apollo.MutationFunction<UpdateAddOnMutation, UpdateAddOnMutationVariables>;

/**
 * __useUpdateAddOnMutation__
 *
 * To run a mutation, you first call `useUpdateAddOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddOnMutation, { data, loading, error }] = useUpdateAddOnMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAddOnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddOnMutation, UpdateAddOnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddOnMutation, UpdateAddOnMutationVariables>(UpdateAddOnDocument, options);
      }
export type UpdateAddOnMutationHookResult = ReturnType<typeof useUpdateAddOnMutation>;
export type UpdateAddOnMutationResult = Apollo.MutationResult<UpdateAddOnMutation>;
export type UpdateAddOnMutationOptions = Apollo.BaseMutationOptions<UpdateAddOnMutation, UpdateAddOnMutationVariables>;
export const RemoveAddOnDocument = gql`
    mutation removeAddOn($id: ID!) {
  removeAddOn(id: $id)
}
    `;
export type RemoveAddOnMutationFn = Apollo.MutationFunction<RemoveAddOnMutation, RemoveAddOnMutationVariables>;

/**
 * __useRemoveAddOnMutation__
 *
 * To run a mutation, you first call `useRemoveAddOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAddOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAddOnMutation, { data, loading, error }] = useRemoveAddOnMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAddOnMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAddOnMutation, RemoveAddOnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAddOnMutation, RemoveAddOnMutationVariables>(RemoveAddOnDocument, options);
      }
export type RemoveAddOnMutationHookResult = ReturnType<typeof useRemoveAddOnMutation>;
export type RemoveAddOnMutationResult = Apollo.MutationResult<RemoveAddOnMutation>;
export type RemoveAddOnMutationOptions = Apollo.BaseMutationOptions<RemoveAddOnMutation, RemoveAddOnMutationVariables>;
export const UpdateAddOnOrdersDocument = gql`
    mutation updateAddOnOrders($data: [UpdateAddOnOrderInput!]!) {
  updateAddOnOrders(data: $data) {
    ...AddOnFormFields
  }
}
    ${AddOnFormFieldsFragmentDoc}`;
export type UpdateAddOnOrdersMutationFn = Apollo.MutationFunction<UpdateAddOnOrdersMutation, UpdateAddOnOrdersMutationVariables>;

/**
 * __useUpdateAddOnOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateAddOnOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddOnOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddOnOrdersMutation, { data, loading, error }] = useUpdateAddOnOrdersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAddOnOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddOnOrdersMutation, UpdateAddOnOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddOnOrdersMutation, UpdateAddOnOrdersMutationVariables>(UpdateAddOnOrdersDocument, options);
      }
export type UpdateAddOnOrdersMutationHookResult = ReturnType<typeof useUpdateAddOnOrdersMutation>;
export type UpdateAddOnOrdersMutationResult = Apollo.MutationResult<UpdateAddOnOrdersMutation>;
export type UpdateAddOnOrdersMutationOptions = Apollo.BaseMutationOptions<UpdateAddOnOrdersMutation, UpdateAddOnOrdersMutationVariables>;